import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, popupSales } from '../data/content';
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const cycle = (i: number) => {
      timeout = setTimeout(() => {
        setIndex(i % popupSales.length);
        setVisible(true);
        timeout = setTimeout(() => {
          setVisible(false);
          cycle(i + 1);
        }, 5200);
      }, 3200);
    };
    cycle(0);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  const sale = popupSales[index];
  return <AnimatePresence data-id="element-129" data-mp="1dpovuhvciwkj">
      {visible && !dismissed ? <motion.aside initial={{
      opacity: 0,
      y: 14,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 14,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-2 left-2 z-50 w-60 overflow-hidden rounded-lg border-2 border-gold bg-white shadow-[0_8px_22px_-6px_rgba(7,29,59,0.6)] sm:w-72" aria-live="polite" data-id="element-130" data-mp="18q2i87blveb7">
          <div className="flex items-center gap-1.5 bg-electric px-2 py-1" data-id="element-131" data-mp="2ei265f1lodbm">
            <span className="text-sm leading-none" aria-hidden="true" data-id="element-132" data-mp="2ih2lgnkvcxtv">
              🧠
            </span>
            <p className="font-heading text-[0.6rem] font-extrabold uppercase tracking-widest text-navy" data-id="element-133" data-mp="2ng5o61ddmryo">
              New purchase verified
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="ml-auto text-navy/70 transition-colors duration-150 ease-out hover:text-navy" data-id="element-134" data-mp="2xfd7d56slgtp">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-135" data-mp="131lyw90792zu" />
            </button>
          </div>
          <a href={PURCHASE_ANCHOR} className="block px-2 py-1.5" data-id="element-136" data-mp="v0wfi1npgf50">
            <p className="text-xs font-bold leading-tight text-navy" data-id="element-137" data-mp="q2cohmu98d5s">
              {sale.name} just bought NEUROLOGY VISUAL ATLAS™
            </p>
            <p className="mt-0.5 text-[0.65rem] font-semibold text-ink/70" data-id="element-138" data-mp="14wr5jhu9dcht">
              {sale.city}, {sale.country} • a few minutes ago
            </p>
          </a>
        </motion.aside> : null}
    </AnimatePresence>;
}